module.exports = __webpack_public_path__ + "img/11.4462e673.jpg";